import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IVariableMessageSign } from '@obvious.tech/constellation'

export const VariableMessageSign = defineEntity('VariableMessageSign', {
  endpoint: 'variablemessagesigns/api/VariableMessageSign',
  schema: SNoop<IVariableMessageSign>(),
})
